import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import { setUserDetail } from "../../core/redux/action";
import UserServices from "../../services/User";
import { useForm } from "react-hook-form";
import InputField from "../components/Input";
import { IMAGE_BASE_URL } from "../../config/constants";
const Profile = () => {

  const dispatch = useDispatch();

  const { userData } = useSelector((state) => {
    return {
      userData: state.user_detail
    }
  });

  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();

  const [loading, setLoading] = useState(false);

  // *For Logo
  const [isLogo, setIsLogo] = useState({});

  // *For Upload Image
  const allowFilesType = ['image/png', 'image/jpg', 'image/jpeg']
  const handleUploadImage = (e) => {
    try {
      if (e.target.value !== "") {
        const file = e.target.files[0]

        if (file.size > 1024 * 1024) { // 1 MB limit
          ErrorToaster("File size must be less than 1MB");
          return;
        }

        if (allowFilesType.includes(file.type)) {
          const imgReader = new FileReader();
          imgReader.onload = (event) => {
            let obj = {
              file: file,
              image: event.target.result
            }
            setIsLogo(obj)
          };
          imgReader.readAsDataURL(file);
        } else {
          ErrorToaster("Only png, jpg, and jpeg formats is supported")
        }
      }
    } catch (error) {
      console.log('handleUploadImage => error:', error)
    }
  };

  // *For Submit Form
  const submitForm = async (payload) => {
    setLoading(true)
    try {
      const formData = new FormData();
      formData.append('name', payload?.name);
      formData.append('phone', payload?.phone);
      formData.append('ntn_cnic', payload?.ntnCnic);
      formData.append('address', payload?.address);
      formData.append('province', payload?.province);
      if (isLogo?.file) {
        formData.append('logo', isLogo?.file);
      }
      const { message, data } = await UserServices.updateUser(userData?.id, formData)
      SuccessToaster(message)
      dispatch(setUserDetail({ ...userData, ...data }))
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (userData) {
      setValue("name", userData?.name)
      setValue("phone", userData?.phone)
      setValue("email", userData?.email)
      setValue("ntnCnic", userData?.ntn_cnic)
      setValue("address", userData?.address)
      setValue("province", userData?.province)
      setIsLogo({
        file: null,
        image: `${IMAGE_BASE_URL}${userData?.logo}`
      })
    }
  }, [userData]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profile</h4>
            <h6>User Profile</h6>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-head"></div>
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg">
                    <img
                      src={isLogo?.image}
                      alt="img"
                      style={{
                        width: "110px",
                        height: "110px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="profileupload">
                      <input type="file" id="imgInp" onChange={(e) => handleUploadImage(e)} />
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/edit-set.svg"
                          alt="img"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="profile-contentname">
                    <h2>{userData?.name}</h2>
                    <h4>Updates Your Logo and Personal Details.</h4>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit(submitForm)}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Name*"
                      type="text"
                      error={errors?.name?.message}
                      register={register("name", {
                        required: 'Please enter store name.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Phone"
                      type="tel"
                      register={register("phone")}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Email"
                      type="email"
                      disabled={true}
                      register={register("email")}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="NTN/CNIC*"
                      type="text"
                      error={errors?.ntnCnic?.message}
                      register={register("ntnCnic", {
                        required: 'Please enter NTN/CNIC.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Address*"
                      type="text"
                      error={errors?.address?.message}
                      register={register("address", {
                        required: 'Please enter address.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Province*"
                      type="text"
                      error={errors?.province?.message}
                      register={register("province", {
                        required: 'Please enter province.',
                      })}
                    />
                  </div>
                </div>
                <div className="text-end col-12">
                  <button
                    type="submit"
                    className="btn btn-submit"
                    disabled={loading}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
